/* eslint-disable */
export default {
  ringing: 'Llamada entrante',
  callConnected: 'Llamada conectada',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
